import _ from 'lodash';

export const getAverageRating = ({ ratings }) => {
  const innovation = _.mean(_.map(ratings, rating => rating.innovation));
  const adaptation = _.mean(_.map(ratings, rating => rating.adaptation));

  return { innovation, adaptation };
};

export const getUserRating = ({ ratings, user }) => {
  return _.find(ratings, rating => rating.author === _.get(user, 'id'));
};

export const removeUserRatingFromRatings = ({ ratings, user, userRating }) => {
  return _.filter(ratings, rating => rating.author !== _.get(user, 'id'));
};

export const limitPercentageValue = value => {
  if (value < 0) {
    return 0;
  }

  if (value > 100) {
    return 100;
  }

  return value;
};
